// extracted by mini-css-extract-plugin
export default {"searchViewContainer":"SearchView_searchViewContainer__qIPpt"};